import * as d3 from "d3";

import { Data } from "../../types";

/**
 * This function assigns be_transparent class to the desired nodes.
 * This is used in highighting the correct nodes when clicked.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

export function highlightNodes({ nodes, links }: Data, node: string) {
  // Finding the desired links and nodes to highlight
  const visibleLinks = links.filter(
    link => link.source === node || link.target === node
  );

  const highlightedNodes = nodes.filter(node =>
    visibleLinks.find(l => l.source === node.id || l.target === node.id)
  );

  // Fixes a bug, where some of the paths won't highlight correctly, don't know why :/
  d3.selectAll("#be_graph > g > g path").attr("class", () => "be_transparent");

  // Highlighting links
  links.forEach(link => {
    d3.select(`#${link.id}`).attr("class", () => {
      const show = visibleLinks.some(vL => vL.id === link.id);
      return show ? "" : "be_transparent";
    });
  });

  // Highlighting nodes
  nodes.forEach(node => {
    d3.select(`#g${node.id}`).attr("class", () => {
      const show = highlightedNodes.some(hN => hN.id === node.id);
      return show ? "" : "be_transparent";
    });
  });

  // Higlighting the clicked node, this is for when a node has no links
  d3.select(`#g${node}`).attr("class", "");
}

export function unHighlightNodes() {
  const transparent = document.getElementsByClassName("be_transparent");
  while (transparent.length) transparent[0].classList.remove("be_transparent");
}
